// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const diancie: PokeData = {
  "id": 719,
  "name": "diancie",
  "height": 7,
  "weight": 88,
  "base_experience": 270,
  "types": [
    PokeType.ROCK,
    PokeType.FAIRY
  ],
  "api_moves": [
    "tackle",
    "rock-throw",
    "harden",
    "light-screen",
    "reflect",
    "rock-slide",
    "sharpen",
    "flail",
    "safeguard",
    "ancient-power",
    "skill-swap",
    "rock-polish",
    "power-gem",
    "trick-room",
    "stone-edge",
    "stealth-rock",
    "guard-split",
    "smack-down",
    "moonblast",
    "diamond-storm"
  ],
  "moves": [
    "tackle",
    "rock-throw",
    "reflect",
    "rock-slide",
    "ancient-power",
    "stealth-rock",
    "moonblast",
    "misty-terrain",
    "spirit-break",
    "rock-blast",
    "power-siphon",
    "moonlight",
    "play-rough"
  ],
  "evolution_chain": {
    "id": 371,
    "item": null,
    "species": [
      {
        "name": "diancie",
        "order": 719,
        "types": [
          PokeType.ROCK,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 160,
    "speed": 80,
    "ability_power": 160
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
